"use client"

import { useAutoAnimate } from "@formkit/auto-animate/react"
import { npPagePxClassName } from "src/components/generic/constants"
import { ErrorMessage } from "src/components/generic/ErrorMessage"
import { mapLineBreaksToHtmlBreaks } from "src/utilities/html"
import { EmailSignupForm } from "./EmailSignupForm"

export type EmailSignupSectionProps = {
  scrollId?: string
  listId?: string | null
  heading?: string | null
  description?: string | null
}

export const EmailSignupSection = ({ scrollId, listId, heading, description }: EmailSignupSectionProps) => {
  const [animationParent] = useAutoAnimate()

  return (
    <section id={scrollId} aria-label={heading || undefined} className={npPagePxClassName}>
      <div
        ref={animationParent}
        className="relative mx-auto flex w-240 max-w-full flex-col gap-8 overflow-hidden text-center font-light text-pretty xl:gap-10"
      >
        <div className="flex flex-col gap-4 xl:gap-6">
          <h2 className="text-h2-np xl:text-h1-np m-0">{heading}</h2>
          <p
            className="text-lg xl:text-2xl"
            dangerouslySetInnerHTML={{ __html: mapLineBreaksToHtmlBreaks(description || "") }}
          />
        </div>

        {listId ? (
          <EmailSignupForm listId={listId} name={heading || listId} context="section" />
        ) : (
          <ErrorMessage message="Keine listId hinterlegt." />
        )}
      </div>
    </section>
  )
}
